import '@/js/buynow.js';
import '@/js/cards.js';
import '@/js/products.js';
import '@/js/video.js';

const $header = $('[data-role=header]');
const $buyNow = $('[data-role=buy-now]');
const $cards = $('[data-role=cards]');
const $products = $('[data-role=choose-sunscreen]');
const $video = $('[data-role=video]');
$(function() {
    $buyNow.buynow();
    $cards.cards();
    $products.products();
    $video.video();

    $(window).scroll(()=> {
        $header.toggleClass('_fixed', $(this).scrollTop() > 1);
    });
});